import { AnimatePresence, motion } from "framer-motion";
import PropTypes from "prop-types";

import logo from "@images/transfr.icon.svg?url";
import logoMedium from "@images/trek-logo.medium.v2.png?url";

export const LogoNavbar = ({ show, expanded }) => {
  return (
    <AnimatePresence initial={false} mode="popLayout">
      {show && (
        <motion.div
          layout
          transition={{ ease: "backOut" }}
          className="logo-container"
        >
          <img src={expanded ? logoMedium : logo} alt="trek logo" />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

LogoNavbar.displayName = "Logo Navbar";

LogoNavbar.propTypes = {
  show: PropTypes.bool,
  expanded: PropTypes.bool,
};
